<template>
  <div></div>
</template>

<script>
export default {
  components: {},
  created() {
    if (this.$route.params.acctoken == null) {
      this.onLogInOauth();
    }
  },
  methods: {
    onLogInOauth() {
      const SRITRANG_LOGIN_URL = process.env.VUE_APP_SRITRANG_LOGIN_URL;
      const SRITRANG_LOGIN_TOKEN = process.env.VUE_APP_SRITRANG_LOGIN_TOKEN;

      let token = SRITRANG_LOGIN_TOKEN;
      let urlstaoauth = SRITRANG_LOGIN_URL;
      var form = document.createElement("form");
      form.method = "GET";
      form.action = urlstaoauth;

      var localtoken = document.createElement("input");
      localtoken.name = "localtoken";
      localtoken.value = token;
      localtoken.type = "hidden";
      form.appendChild(localtoken);

      document.body.appendChild(form);
      form.submit();
    },
  },
};
</script>
